import React, { useState, useEffect } from "react";
import Axios from "axios";
import { API_BASE_URL, GET_SUPPLIER_PAYMENTS_VIEW } from "../../../Config";
import PropTypes from "prop-types";
import "jspdf-autotable";
import GenerateInvoicePayment from "./invoicepayment";

const ViewSupplierPayments = ({ POObj }) => {

  const [userDataSession, setUserDataSession] = useState([]);
  const [loading, setLoading] = useState("");
  const [firstData, setFirstData] = useState(null);
  const [viewProducts, setViewProducts] = useState([]);
  const [paymentInvoiceData, setPaymentInvoiceObj] = useState([]); 

  // #region Session userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && POObj && POObj.SupplierId) {
      setLoading(true);
      const url = `${API_BASE_URL}${GET_SUPPLIER_PAYMENTS_VIEW}?SupplierId=${POObj.SupplierId}&OrgId=${userDataSession.OrgId}`;
      Axios.get(url)
        .then((response) => {
          if (response.data.Status) {
            setViewProducts(response.data.ResultData);
            setFirstData(response.data.ResultData[0]);
            console.log(response.data.ResultData, "req details");
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [userDataSession, POObj]);

  const showPaymentModal = (purchaseObj) => {
    setPaymentInvoiceObj(purchaseObj);
  };

  return (
    <div>
        <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasRightSuppPaysView"
            aria-labelledby="offcanvasRightLabel" style={{ minWidth: "65%" , maxWidth: "65%" }}>
            <div className="offcanvas-header">
                <h4 id="offcanvasRightLabel" className="me-3">Payments View</h4>

                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" />
            </div>
            <hr />
            <div className="offcanvas-body">
                <form>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-blocks add-product">
                                <label>Supplier</label>
                                <div className="row">
                                    <div className="col-lg-10 col-sm-10 col-10">
                                        <input 
                                          type="text" 
                                          className="form-control" 
                                          value={POObj?.SupplierName} 
                                          readOnly 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-blocks">
                                <label>Purchase Date</label>
                                <div className="input-groupicon calender-input">
                                    <input 
                                      type="text" 
                                      className="form-control" 
                                      value={formatDate(firstData?.PODate)} 
                                      readOnly 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-lg-12">
                            <div className="modal-body-table">
                                <div className="table-responsive" style={{ maxHeight: '20rem', overflowY: 'auto' }}>
                                    <table className="table  dataew">
                                        <thead className="sticky-top">
                                            <tr>
                                                <th>#</th>
                                                <th>PO Number</th>
                                                <th>PO Date</th>
                                                <th>Total Amount <i className="fa-solid fa-indian-rupee-sign"></i></th>
                                                <th>Paid Amount <i className="fa-solid fa-indian-rupee-sign"></i></th>
                                                <th>Due Amount <i className="fa-solid fa-indian-rupee-sign"></i></th>
                                                <th>Payment</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    Loading...
                                                </td>
                                            </tr>
                                            ) : viewProducts.length !== 0 ? (
                                            viewProducts.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>PO-{item.AutoGenTransactionNo}</td>
                                                <td>{formatDate(item.PODate)}</td>
                                                <td className="text-info fw-bold">{item.InvoiceAmount ? item.InvoiceAmount : 0}</td>
                                                <td className="text-success fw-bold">{item.PaidAmount ? item.PaidAmount : 0}</td>
                                                <td className="text-danger fw-bold">{((item.InvoiceAmount ? item.InvoiceAmount : 0) - (item.PaidAmount ? item.PaidAmount : 0)).toFixed(2)}</td>
                                                <td title="Make Payment">
                                                  <i 
                                                    className={`fa-solid fa-coins me-2 fs-4 text-info ${item.InvoiceStatus == 'PAID' ? 'disabled' : ''}`}
                                                    data-bs-toggle="offcanvas"
                                                    data-bs-target={item.InvoiceStatus !== 'paid' ? "#offcanvasRightInvPayment" : ''}
                                                    aria-controls="offcanvasRightInvPayment"
                                                    onClick={item.InvoiceStatus !== 'paid' ? () => showPaymentModal(item) : null}
                                                    style={{ cursor: 'pointer' }}
                                                  ></i>
                                                </td>
                                            </tr>
                                            ))
                                            ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center">
                                                    No Data available
                                                </td>
                                            </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <GenerateInvoicePayment INVObj={paymentInvoiceData} />
    </div>
  );
};

ViewSupplierPayments.propTypes = {
  POObj: PropTypes.object.isRequired,
};

export default ViewSupplierPayments;
